import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Destinations from './components/Destinations';
import About from './components/About';
import Enquiry from './components/Enquiry';
import TouristSpots from './components/TouristSpots';
import BookNow from './components/BookNow';
import TouristSpotDetails from './components/TouristSpotDetails';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './components/Profile';
import './App.css';


function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main style={{ padding: '1rem', position: 'relative', zIndex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/about" element={<About />} />
            <Route 
              path="/contact" 
              element={
                <ProtectedRoute>
                  <Enquiry />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route path="/destinations/:countryName" element={<TouristSpots />} />
            <Route path="/destinations/:countryName/:spotName" element={<TouristSpotDetails />} />
            <Route 
              path="/book-now" 
              element={
                <ProtectedRoute>
                  <BookNow />
                </ProtectedRoute>
              } 
            />
            
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;